module.exports = __webpack_public_path__ + "static/img/meri.089db0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/groom/meri.jpg
// module id = 2hR+
// module chunks = 1